const UNIT_SCALARS = ['', 'K', 'M', 'B', 'T'];
export const UNIT_DECORATORS = ['$', '%', ','];

export const getValueWithUnits = (value, valueType) => {
  let returnValue = value;
  switch (valueType) {
    case 'percent':
      returnValue = `${value}%`;
      break;

    case 'dollar':
    case 'currency':
      if(String(value).charAt(0) === '-'){
        returnValue = `-$${value.substring(1)}`;
      } else {
        returnValue = `$${value}`;
      }
      break;

    default:
      returnValue = value;
      break;
  }
  return returnValue;
};

export const getScaledValue = (value, valueType) => {
  const digitCount = String(Math.round(value)).length;
  const segmentLabelIndex = Math.floor((digitCount - 1) / 3);

  const valueLabel = UNIT_SCALARS[segmentLabelIndex];
  const scaledValue = value / 10 ** (3 * segmentLabelIndex);

  const scaledValueText = `${scaledValue}${valueLabel}`;

  if (typeof valueType !== 'undefined') {
    return getValueWithUnits(scaledValueText, valueType);
  }

  return scaledValueText;
};

export const getRawValue = (value) => {

  if(typeof value === 'undefined'){
    return Number.NaN;
  }

  const decoratorRegexFragment = UNIT_DECORATORS.join('|');
  const decoratorRegex = new RegExp(`[${decoratorRegexFragment}]`, 'g');
  const rawValue = String(value).replace(decoratorRegex, '');
  const scalarUnit = rawValue.slice(-1);

  if(UNIT_SCALARS.includes(scalarUnit)){
    const number = parseFloat(rawValue.slice(0, -1), 10);
    const scalarPower = 3 * UNIT_SCALARS.indexOf(scalarUnit);
    return number * (10 ** scalarPower);
  }

  return parseFloat(rawValue, 10);
};

export const preciseRound = (value, precision) => {
  const roundingScale = 10 ** precision;
  return Math.round(value * roundingScale) / roundingScale;
};

export const zeroFill = (number, precision) => {
  let leadingZeroes = '';
  for(let zeroCount = precision; zeroCount > 0; zeroCount--){
    leadingZeroes += '0';
  }

  return `${leadingZeroes}${number}`.slice(precision * -1);
};

export const formatValue = (value, valueType, precision) => {
  if(value === ''){
    return '';
  }

  const formattedValue = Number(value).toLocaleString('en-US', {
    minimumFractionDigits: precision
  });
  return getValueWithUnits(formattedValue, valueType);
}